import {generateRouteTo} from 'epic-fortnite-react';
import classNames from 'classnames';
import epicTracking from 'epic-tracking';
import PropTypes from 'prop-types';
import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import root from 'window-or-global';

import DownloadButton from './DownloadButton';

/**
 * Client Download Page.
 */
class ClientDownloadDropDown extends React.Component {
  static propTypes = {
    supportedOS: PropTypes.array.isRequired,
    data: PropTypes.object.isRequired,
    className: PropTypes.string,
    align: PropTypes.string,
    headerStyle: PropTypes.object,
    alertJSX: PropTypes.element,
    showAlert: PropTypes.bool,
    legalTags: PropTypes.array,
    legalTagsColor: PropTypes.string,
    availableColor: PropTypes.string,
    appConfigStore: PropTypes.object,
    mobileStore: PropTypes.object,
    messages: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    children: PropTypes.node,
  };

  constructor(props) {
    super(props);
    const currentOS = this.props.supportedOS.reduce((accumulator, os) => {
      if (root._epicGamesNav.browser[os.toLowerCase()]) {
        return os.toLowerCase();
      }
      return accumulator;
    }, '');
    this.state = {
      currentOS,
      selectedOS: '',
    };
  }

  getBrowserOS() {
    return root._epicGamesNav.browser.osname.toLowerCase();
  }

  onSelect = (e) => {
    epicTracking.trackEvent('Interaction', {
      interactionType: 'click',
      eventCategory: 'downloadPage022019',
      eventAction: 'selectDropDown',
      eventLabel: e.target.value,
    });
    this.setState({currentOS: e.target.value, selectedOS: e.target.value});
  };

  render() {
    const {currentOS, selectedOS} = this.state;
    const {
      messages,
      data: {returnText},
      downloadThankYouText,
      history,
      match,
      headerStyle,
      legalTagsColor,
      availableColor,
      location,
    } = this.props;

    const availableStyles = {};

    if (availableColor) {
      availableStyles.color = availableColor;
    }

    const canDownload = ['mac', 'windows'].indexOf(currentOS) !== -1;
    const {appConfigStore, mobileStore} = this.props;
    const {countryCode} = appConfigStore;
    const isMobile =
      root._epicGamesNav.browser.ios ||
      root._epicGamesNav.browser.ipad ||
      root._epicGamesNav.browser.android;

    let downloadBody = (
      <div>
        {this.props.showAlert && this.props.alertJSX}
        {!isMobile && canDownload ? (
          <p className="candownload" style={headerStyle}>
            {messages['epic.fortnite.download.candownload']}
          </p>
        ) : (
          <p className="candownload" style={headerStyle}>
            {messages['epic.fortnite.download.downloadandplay']}
          </p>
        )}
        <div className="selectPlatform" style={availableStyles}>
          {messages['epic.fortnite.download.clicktodownload']}
        </div>
        <div className="downloadButtons">
          <DownloadButton
            os={currentOS}
            countryCode={countryCode}
            appConfigStore={appConfigStore}
            messages={messages}
            mobile={isMobile}
            mobileStore={mobileStore}
            history={history}
            match={match}
            disableText={true}
          />
        </div>
      </div>
    );

    const legalTags = this.props.legalTags || [];
    const bottomImgs = [];
    if (legalTags.length) {
      legalTags.forEach((tag, index) => {
        const temp = (
          <li className="tag-container" key={tag.src}>
            <p className="tag-title accent-color">{tag.title}</p>
            <img className="bottomImg" alt={tag.title} src={tag.src} />
          </li>
        );
        bottomImgs.push(temp);
      });
    }
    const legalTagsStyle = {
      color: legalTagsColor || 'white',
    };

    const isMobileOSSelected =
      ['ios', 'android', 'nintendo', 'psn', 'xbl'].indexOf(currentOS) !== -1;
    if (isMobile && !isMobileOSSelected) {
      downloadBody = (
        <p style={headerStyle} className="mobileMsg" data-testid="no-ios-download-msg">
          {messages['epic.fortnite.download.chooseanother']}
        </p>
      );
    }
    if (isMobile && !isMobileOSSelected && selectedOS === 'windows') {
      downloadBody = (
        <p style={headerStyle} className="mobileMsg" data-testid="pc-msg">
          {messages['epic.fortnite.download.chooseanother']}
        </p>
      );
    }
    if (isMobile && !isMobileOSSelected && selectedOS === 'mac') {
      downloadBody = (
        <p style={headerStyle} className="mobileMsg" data-testid="mac-msg">
          {messages['epic.fortnite.download.chooseanother']}
        </p>
      );
    }
    const classes = classNames(this.props.className);
    const innerClasses = classNames('LPdlinnerwrapper', this.props.className);

    /* eslint-disable jsx-a11y/no-onchange */
    return (
      <div className={innerClasses}>
        <div className={classes}>
          {this.props.children ? (
            <div className="download-header-container">{this.props.children}</div>
          ) : (
            <div
              style={headerStyle}
              dangerouslySetInnerHTML={{__html: downloadThankYouText?.content}}
            />
          )}
          {downloadBody}
          <p className="available" style={headerStyle}>
            {messages['epic.fortnite.landingpage.fortniteavailable']}
          </p>
          <div className="select-container">
            <select name="os" value={selectedOS} onChange={this.onSelect}>
              <option value="">{messages['epic.fortnite.download.chooseanother']}</option>
              {this.props.supportedOS.map((os) => (
                <option key={os} value={os.toLowerCase()}>
                  {messages[`epic.common.${os.toLowerCase()}`]}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="legalTags" style={legalTagsStyle}>
          <ul className="downloadLegalTags">{bottomImgs}</ul>
          <Link to={generateRouteTo('/', location)} className="returnLink" style={headerStyle}>
            {returnText || messages['epic.fortnite.landingpage.visitfortnite']}
          </Link>
        </div>
      </div>
    );
  }
}
export default withRouter(ClientDownloadDropDown);
